import axios from '../axios'

// const brandAPI = {
//   getBrandList: () => {
//     return axios({
//       url: '/recycle/product/category/list',
//       method: 'get'
//     })
//   },
// }

  // const getBrandList = () => {
  //   return axios({
  //     url: '/recycle/product/category/list',
  //     method: 'get'
  //   })
  // }

const getBrandList = params => {
  return axios({
    url: '/recycle/product/brand/list',
    method: 'get',
    params
  })
}

const getModelList = params => {
  return axios({
    url: '/recycle/product/product/list',
    method: 'get',
    params
  })
}

export {
  getBrandList,
  getModelList
}
